import { graphql } from "@/lib/gql/__generated__/gql";

export const SNACK_LIST_FOR_DESIGN_PLAIN_QUERY = graphql(/* GraphQL */ `
	query SnackListForDesignPlain($hotelID: ID!) {
		snackList(hotelID: $hotelID) {
			snacks {
				id
				uuid
				snackType
				isPublished
				title
				thumbnail
				snack {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
